import { FC, ReactNode } from 'react';
import { Paper, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';

interface InfoCardProps {
  icon: ReactNode;
  title: string;
  description: string;
}

export const InfoCard: FC<InfoCardProps> = observer(({ icon, title, description }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        maxWidth: '214px',
      }}
    >
      {icon}

      <Typography
        variant="body1"
        sx={{ fontWeight: 500, fontSize: '0.875rem', textAlign: 'center', mt: 3 }}
      >
        {title}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          fontWeight: 500,
          fontSize: '0.875rem',
          textAlign: 'center',
          color: 'text.tertiary',
          mt: 0.5,
        }}
      >
        {description}
      </Typography>
    </Paper>
  );
});
